import PropTypes from 'prop-types'
import Tooltip from '../../common/tooltip'
import { formatEmptyValue, humanizeBool } from '../../../utils/common'
import { Edit, Trash } from '@styled-icons/boxicons-solid'

const ModulesRow = (props) => {
  let connectors = props?.connector.map((obj) => obj.name)
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-1 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-3/12 items-center table_text">
          <Tooltip message={props?.acronym}>
            <div>{formatEmptyValue(props?.acronym)}</div>
          </Tooltip>
        </div>
        <div className="flex w-2/12 pl-6 items-center table_text">
          <Tooltip message={props?.module_id}>
            <div>{formatEmptyValue(props?.module_id)}</div>
          </Tooltip>
        </div>
        <div className="w-5/12 pl-6 items-center table_text">
          {props?.connector?.length > 0 ? (
            <Tooltip message={connectors.join(',')}>
              {connectors.join(',')}
            </Tooltip>
          ) : (
            '-'
          )}
        </div>
        <div className="flex w-1/12 pl-6 items-center">
          {humanizeBool(props?.is_dtc_exists)}
        </div>

        <div className="flex w-1/12 pl-6 items-center justify-end">
          <span
            onClick={() => {
              props.onShowDetails()
            }}
            className="cursor-pointer px-1"
          >
            <Edit size="2rem" color="#0189E9" />
          </span>
          <span
            onClick={() => {
              props.onDelete()
            }}
            className="cursor-pointer px-1"
          >
            <Trash size="2rem" color="#0189E9" />
          </span>
        </div>
      </div>
    </div>
  )
}

ModulesRow.propTypes = {
  connector: PropTypes.array,
  ecu: PropTypes.object,
  onShowDetails: PropTypes.func,
}

export default ModulesRow
